export default "__VITE_ASSET__X5OHz3KI__"